/* eslint-disable max-len */
export const errors = {
  'service-is-unavailable': 'Ծառայությունը ժամանակավորապես անհասանելի է․ փորձեք ավելի ուշ',
  'cannot-get-telegram-link': 'Չի հաջողվել ստանալ Telegram-ի հղումը',
  'maybe-error': 'Հնարավոր է՝ առկա է սխալ',
  'check-email': 'Համոզվեք, որ էլ․ հասցեն ճիշտ է, որպեսզի կարողանանք կապ հաստատել Ձեզ հետ։',
  'check-input-correctness': 'Ստուգե՛ք մուտքագրված տվյալների ճշտությունը։',
  'link-possibly-expired': 'Հնարավոր է, որ հղումը հնացել է կամ բացակայում է ձևանմուշը։ Դիմեք ՍՄ-ի սպասարկման ծառայություն',
  'interview-has-already-been-recorded': 'Հարցազրույցն արդեն ձայնագրվել է նախկինում',
  'use-are-using-outdated-browser': 'Ցավոք, Ձեր դիտարկիչը համատեղելի չէ ժամանակակից տեխնոլոգիաների հետ, և որոշ գործառույթներ, ինչպես օրինակ՝ տեսաձայնագրումը, կարող են անհասանելի լինել։ Ճիշտ աշխատանքի և տվյալների ցուցադրման համար օգտագործեք Chrome, FireFox կամ Edge դիտարկիչներ։',
  'questionnaire-was-not-sent': 'Հարցաթերթիկը չի ուղարկվել',
  'check-data-correctness': 'Ստուգեք մուտքագրված տվյալների ճշգրտությունը։',
  error: 'Սխալ',
  'connot-load-questionnaire-template': 'Չհաջողվեց բեռնել հարցաթերթիկի ձևանմուշը։ Դիմեք սպասարկման ծառայություն։',
  'somthing-went-wrong-try-leter': 'Առկա է սխալ։ Փորձեք բացել էջը ավելի ուշ։',
  'no-answer-was-sent': 'Պատասխանը չի ուղարկվել',
  'you-can-choose-only-one-variant': 'Կարելի է ընտրել միայն մեկ տարբերակ',
  'full-name-must-contain-three-words': 'ԱԱՀ-ն պետք է պարունակի ուղիղ երեք բառ, որոնք պիտի միմյանցից անջատված լինեն բացատներով։',
  'phone-must-have-format': 'Հեռախոսահամարը պետք է ունենա հետևյալ ձևաչափը՝ +374 (NN) NN-NN-NN։',
  'video-interview-has-already-been-created': 'Տեսահարցազրույցն արդեն ստեղծվել է․ անցեք հարցազրույցի։',
};
